import { addProject } from "../apigateway/mongocalls";
import getuser from "../aws_utils/getAuthuser";


export default async function createNewProject(projectname) {

    if(projectname === "" || projectname === null || projectname === undefined){
        alert('Create or Select Project')
        return
    }

   
    let userid = ""
    try {
        const currentuser = await getuser()
        userid = currentuser.username
        // console.log("Sub id", currentuser.username)
    } catch (error) {
        console.log(error)
    }

    try {
        await addProject(userid, projectname)
    } catch (error) {
        console.log('add porject error')
    }
    

 

  
}
